import axios from 'axios'

const instance = axios.create({
	baseURL: process.env.REACT_APP_API_PROTOCOL + '://' + process.env.REACT_APP_API_HOST,
	// withCredentials: true,
})

instance.interceptors.request.use(
	(config) => {
		return config
	},
	(error) => {
		return Promise.reject(error)
	}
)

instance.interceptors.response.use(
	(response) => response,
	(error) => Promise.reject(error)
)

export default instance
